// --- Polyfills ---
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'core-js/features/promise';

// --- Vue Core ---
import Vue from 'vue';
import App from './App';
import router from './router';
import { i18n } from './locale';

// --- UI Libraries ---

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import '@glidejs/glide/dist/css/glide.core.min.css';
// import 'swiper/dist/css/swiper.css';

import './js/browserPatch'
import "../theme/index.css";

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper /* { default options with global component } */);

import '../static/component.css'

// --- Utilities ---
import axios from 'axios';
import * as http from './js/http';
import 'lib-flexible/flexible.js';
import { defaultProLang } from './locale/utils';

// --- Vue Configuration ---
Vue.config.productionTip = false;
Vue.config.performance = process.env.NODE_ENV === 'development';

// --- Error Handler ---
Vue.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err);
  if (process.env.NODE_ENV === 'production') {
    // Add production error tracking here
  }
};


Vue.prototype.$http = http;
// --- HTTP Client Setup ---
// const axiosInstance = axios.create({
//   timeout: 10000,
//   headers: {
//     'Content-Type': 'application/json'
//   }
// });

// Vue.prototype.$http = http;
// Vue.prototype.$axios = axiosInstance;

// --- Initialize Language ---
defaultProLang();

// --- Vue Instance ---
new Vue({
  el: '#app',
  router,
  i18n,
  axios,
  render: h => h(App),
  beforeCreate() {
    // Add any initialization logic
  }, created() {
    i18n.locale = localStorage.getItem('333f-locale-lang') || "zh_cn"
  },
  mounted() {
    // Remove loading state
    document.body.classList.remove('loading');
  },
  // errorCaptured(err, vm, info) {
  //   console.error('Component Error:', err);
  //   return false;
  // }
});


// WEBPACK FOOTER //
// ./src/main.js